import { amountDataToDisplay } from "../utils/utils";
import { useTranslation } from 'react-i18next';
import { ICONS } from "../constants";

export default function ContributorSettlementRow(props) {
  const { t } = useTranslation();
  const { name, icon, amount, isPaid = false, onOpen } = props;
  const paidLabel = t("general.paid", { defaultValue: "Paid" });

  return (
    <div
      className="ms-4 py-2 d-flex align-items-center justify-content-between as-row-surface"
      style={{ gap: 8, width: "calc(100% - 1.5rem)" }}
      role="button"
      tabIndex={0}
      onClick={() => {
        if (typeof onOpen === "function") onOpen();
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          if (typeof onOpen === "function") onOpen();
        }
      }}
    >
      <div className="d-flex align-items-center" style={{ minWidth: 0, gap: 8 }}>
        <span className="as-owe-garnish" aria-hidden="true">
          <span>🌿</span>
          <span>🌼</span>
          <span>🌱</span>
        </span>
        <div
          className={`truncate ${isPaid ? "text-muted" : ""}`}
          style={isPaid ? { textDecoration: "line-through" } : undefined}
        >
          {t('general.owes')} <span className="flex-shrink-0" aria-hidden="true">{ICONS?.[icon] || "🐾"}</span> {`${name} ${amountDataToDisplay(amount)}`}
        </div>
        {isPaid ? (
          <span className="badge bg-success flex-shrink-0" aria-label={paidLabel} title={paidLabel}>
            {paidLabel}
          </span>
        ) : null}
      </div>
      <div className="d-flex align-items-center gap-2">
        <i className="bi bi-chevron-right as-row-chevron" aria-hidden="true" />
      </div>
    </div>
  );
}
